import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule, MatProgressSpinnerModule, MatSelectModule, MatCheckboxModule
} from '@angular/material';
import {UIRouterModule, StateService} from "@uirouter/angular";
import {HttpClientModule} from "@angular/common/http";

import {kanServiceModule} from "../services/module";
import {kanAdminModule} from '../admin/module';

import {kanUsersService} from "../services/services/users";

import {kanMain} from "./components/main/component";
import {kanHeader} from "./components/header/component";
import {kanLogin} from "./components/login/component";
import {kanUsersAdmin} from "./components/users/component";
import {kanMailing} from "./components/mailing/component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {kanUser} from "../admin/components/user/user/component";
import {kanDog} from "../admin/components/dog/dog/component";
import {TranslateModule} from "@ngx-translate/core";
import {kanDataAdmin} from "./components/admin/component";
import {kanMailsModule} from "../mails/module";
import {kanHome} from "./components/home/component";
import {CKEditorModule} from "ng2-ckeditor";


let resolveApp = {
    token: 'authenticated',
    deps: [StateService, kanUsersService],
    resolveFn: (StateService, kanUsersService) => {
        if (kanUsersService.isAuthenticated()) {
            return true;
        } else {
            StateService.go('app.login');
            return false;
        }
    }
};

let resolveLogin = {
    token: 'authenticated',
    deps: [StateService, kanUsersService],
    resolveFn: (StateService, kanUsersService) => {
        if (kanUsersService.isAuthenticated()) {
            StateService.go('app');
            return true;
        } else {
            return false;
        }
    }
};

let app = {
    abstract: true,
    name: 'app',
    url: '/',
    component: kanMain,
    resolve: []
};

let home = {
    name: 'app.home',
    url: 'home',
    component: kanHome,
    resolve: []
};

let users = {
    name: 'app.users',
    url: 'users',
    component: kanUsersAdmin,
    resolve: []
};

let user = {
    name: 'app.users.user',
    url: 'user/:id',
    component: kanUser,
    resolve: []
};

let dog = {
    name: 'app.users.dog',
    url: 'dog/:id',
    component: kanDog,
    resolve: []
};

let admin = {
    name: 'app.admin',
    url: 'admin',
    component: kanDataAdmin,
    resolve: []
};

let mailing = {
    name: 'app.mailing',
    url: 'mailing',
    component: kanMailing,
    resolve: []
};

let login = {
    name: 'app.login',
    url: 'login',
    component: kanLogin,
    resolve: []
};

app.resolve.push(resolveApp);
home.resolve.push(resolveApp);
users.resolve.push(resolveApp);
mailing.resolve.push(resolveApp);
admin.resolve.push(resolveApp);
login.resolve.push(resolveLogin);

@NgModule({
    declarations: [
        kanMain,
        kanHeader,
        kanLogin,
        kanHome,
        kanUsersAdmin,
        kanDataAdmin,
        kanMailing
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        TranslateModule,
        UIRouterModule.forRoot({states: [app, home, users, user, dog, admin, mailing, login], useHash: true, otherwise: '/home'}),
        MatSidenavModule,
        MatButtonModule,
        MatIconModule,
        MatListModule,
        MatTabsModule,
        MatFormFieldModule,
        MatInputModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatCheckboxModule,
        CKEditorModule,
        kanServiceModule,
        kanAdminModule,
        kanMailsModule
    ],
    exports: [
        kanMain,
        kanHeader,
        kanLogin,
        kanHome,
        kanUsersAdmin,
        kanMailing
    ],
    providers: [],
    bootstrap: [kanMain]
})
export class kanMainModule {
}



// WEBPACK FOOTER //
// ./src/modules/main/module.ts